import React from "react";
import { MapPinOff, SearchX } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LocalVisibilityProblem() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="41902" id="resumen-del-curso" ref={sectionRef} className="relative w-full overflow-hidden bg-background py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-20 lg:items-center">
          {}
          <div className={`flex flex-col gap-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <span className="font-mono text-sm font-bold tracking-wider text-secondary">
              FORMACIÓN PROFESIONAL TÉCNICA
            </span>
            
            <h2 className="font-sans text-4xl font-bold leading-tight tracking-tight text-foreground md:text-5xl lg:text-6xl">
              Técnico Electricista: Domina el Oficio
            </h2>
            
            <div className="space-y-4 text-lg leading-[1.6] text-muted-foreground font-sans">
              <p>
                Capacítate con el respaldo de <span className="font-semibold text-primary">ECAP Uruguay</span>. 
                Nuestro curso está diseñado para convertirte en un profesional capaz de realizar instalaciones 
                eléctricas seguras, eficientes y bajo normativas vigentes.
              </p>
              <p>
                Aprende de forma práctica con expertos en el área. Desde el mantenimiento básico hasta 
                proyectos industriales complejos, te brindamos la experiencia necesaria para una 
                salida laboral inmediata en cualquier punto del país.
              </p>
            </div>
          </div>

          {}
          <div className={`relative mx-auto w-full max-w-lg lg:max-w-none transition-all duration-1000 ease-out delay-200 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="absolute -top-12 -right-12 h-64 w-64 rounded-full bg-primary/20 blur-3xl" />
            <div className="absolute -bottom-12 -left-12 h-64 w-64 rounded-full bg-secondary/10 blur-3xl" />

            {}
            <div className="relative overflow-hidden rounded-3xl border border-border/50 bg-card shadow-2xl">
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/google_maps_visibility_comparison.png" alt="Estudiante de ECAP realizando prácticas de electricidad técnica" className="h-auto w-full object-cover opacity-90 backdrop-blur-[2px]" />

              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent pointer-events-none" />

              {}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform">
                
              </div>

              {}
              <div className="absolute top-[20%] right-[15%] h-16 w-16 rounded-full bg-primary/30 blur-xl animate-pulse" />
            </div>

            {}
            <div className="absolute -bottom-6 -left-6 hidden md:flex items-center gap-3 rounded-2xl border border-border bg-card/80 p-5 shadow-2xl backdrop-blur-md">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
                <MapPinOff className="h-6 w-6" />
              </div>
              <div>
                <p className="text-xs font-bold text-muted-foreground uppercase tracking-widest font-mono">Info del Curso</p>
                <p className="text-sm font-bold text-foreground">5 Meses | Presencial</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}